<template>
  <section>
    <b-card-actions
      :show-loading="loading"
      action-collapse
      :title="$t('Configuração do Contrato de Comodato')"
    >
      <FormulateForm
        ref="lendingContractForm"
        name="lendingContractForm"
        @submit="saveConfiguration"
      >
        <b-row>
          <b-col md="4">
            <FormulateInput
              id="lending_contract-version"
              v-model="configuration.version"
              type="text"
              :label="$t('Versão do Contrato')"
              :placeholder="$t('Ex: 1.0, 2.1, etc.')"
              maxlength="10"
              validation="required|max:10"
              validation-behavior="live"
              :help="$t('Máximo 10 caracteres')"
            />
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="12">
            <FormulateInput
              id="lending_contract-content"
              v-model="configuration.content"
              type="textarea"
              rows="50"
              :label="$t('Conteúdo do Contrato')"
              :placeholder="$t('Digite aqui o conteúdo completo do contrato de comodato...')"
              validation="required"
              validation-behavior="live"
              :help="$t('Este texto será exibido como referência para o contrato de comodato')"
            />
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col
            md="12"
            align="right"
          >
            <e-button
              id="cancel_lending_contract"
              type="button"
              class="mr-2"
              variant="outline-secondary"
              icon="x"
              :text="$t('Cancelar')"
              @click="$router.go(-1)"
            />
            <e-button
              id="save_lending_contract"
              type="submit"
              variant="primary"
              icon="save"
              :text="$t('Salvar')"
            />
          </b-col>
        </b-row>
      </FormulateForm>
    </b-card-actions>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import alerts from '@/mixins/alerts'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import { EButton } from '@/views/components'

export default {
  components: { BCardActions, BRow, BCol, EButton },
  mixins: [alerts],
  data() {
    return {
      loading: false,
      configuration: {
        version: '',
        content: '',
      },
    }
  },
  mounted() {
    this.loadConfiguration()
  },
  methods: {
    async loadConfiguration() {
      try {
        this.loading = true
        const response = await this.$http.get(`/api/lending-contract-configuration`)
        if (response.data) {
          this.configuration = {
            id: response.data.id || null,
            version: response.data.version || '',
            content: response.data.content || '',
          }
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          this.showError({
            title: this.$t('Erro'),
            message: this.$t('Erro ao carregar configuração do contrato de comodato'),
          })
        }
      } finally {
        this.loading = false
      }
    },
    async saveConfiguration() {
      try {
        this.loading = true

        await this.$http.put(`/api/lending-contract-configuration`, {
          ...this.configuration,
        })

        this.showSuccess({
          title: this.$t('Sucesso'),
          message: this.$t('Configuração salva com sucesso!'),
        })
      } catch (error) {
        this.showError({ error })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
